<qr-overlay-topbar (close)="close.emit()">{{
  movement.movementDate | slice : 0 : 10
}}</qr-overlay-topbar>

<div class="container" *ngIf="movement">
  <div class="container__body">
    <div class="container__topbar">
      <div class="container__first">
        <qr-button [config]="btnType"></qr-button>

        <p>{{ movement.movementType }}</p>
      </div>
      <div class="container__second">
        <p>
          TC: {{ movement.currencySymbol
          }}{{ movement.changeType | number : "1.0-0" }}
        </p>
      </div>
    </div>
    <div class="container__concept">
      <p class="container__subtitle">Concepto</p>
      <p class="container__title">{{ movement.concept }}</p>
    </div>
    <div class="container__description">
      <p class="container__subtitle">Descripción</p>
      <p class="container__text">{{ movement.description }}</p>
    </div>
    <div class="container__types">
      <div class="container__type">
        <p class="container__subtitle">Familia</p>
        <p class="container__text">{{ movement.category }}</p>
      </div>
      <div class="container__type--center">
        <p class="container__subtitle">Subfamilia</p>
        <p class="container__text">{{ movement.subcategory }}</p>
      </div>
    </div>
    <div class="container__types">
      <div class="container__type">
        <p class="container__subtitle">Caja</p>
        <p class="container__text">{{ movement.paymentType }}</p>
      </div>
      <div class="container__type--center">
        <p class="container__subtitle">Tipo de compr.</p>
        <p class="container__text">{{ movement.voucherType }}</p>
      </div>
      <div class="container__type">
        <p class="container__subtitle">N° de factura</p>
        <p class="container__text">{{ movement.invoiceNumber ?? "-" }}</p>
      </div>
    </div>
    <div class="container__subtotal">
      <div class="container__item">
        <p>Subtotal</p>
        <p>
          {{
            movement.currency === CURRENCY_DOLLAR
              ? CURRENCY_INTERNATIONAL + " "
              : CURRENCY_LOCAL + " "
          }}{{ movement.subTotal | number : "1.0-0" }}
        </p>
      </div>
      <div class="container__item">
        <p>{{NODE === NODE_DO ? 'ITBIS' : 'IVA'}}</p>
        <p>
          {{ movement.currency === "USD" ? "U$S " : "$ "
          }}{{ movement.ivaCalculated | number : "1.0-0" }}
        </p>
      </div>
      <div class="container__item" *ifNodeHide="[NODE_DO]">
        <p>Percep. IIBB</p>
        <p>
          {{ movement.currency === "USD" ? "U$S " : "$ "
          }}{{ movement.iibb | number : "1.0-0" }}
        </p>
      </div>
      <div class="container__item" *ifNodeHide="[NODE_DO]">
        <p>Otros</p>
        <p>
          {{ movement.currency === "USD" ? "U$S " : "$ "
          }}{{ movement.otros | number : "1.0-0" }}
        </p>
      </div>
      <div class="container__total">
        <p class="container__title--strong">Total</p>
        <p class="container__title--strong">
          {{ movement.currency === "USD" ? "U$S " : "$ "
          }}{{ movement.total | number : "1.0-0" }}
        </p>
      </div>
    </div>
  </div>
</div>
